import { z } from "zod";
import { DateTypeSchema, RoleTypeSchema } from "./core.schema";
import { ContactInfoSchema } from "./contactInfo.schema";

// Schemas

export const TeamMemberClassSchema = z.enum(["voting", "active", "support"]);

export const TeamMemberSchema = z.object({
  title: z.string(),
  userId: z.string(),
  role: RoleTypeSchema,
  class: TeamMemberClassSchema.optional(),
  notifications: z
    .object({
      meetingPublished: z.boolean(),
    })
    .partial()
    .optional(),
  expires: z.boolean().optional(),
  expirationDate: DateTypeSchema.optional(),
  expirationNotification: z.string().array().optional(),
  includeInLetterhead: z.boolean().optional(),
});

export const TeamMemberWContactSchema = TeamMemberSchema.extend({
  contactInfo: ContactInfoSchema,
});

export const PublicTeamMemberSchema = TeamMemberSchema.pick({
  title: true,
  userId: true,
  role: true,
  class: true,
  expires: true,
  expirationDate: true,
});

export const PublicTeamMemberWContactSchema = TeamMemberWContactSchema.pick({
  title: true,
  userId: true,
  role: true,
  class: true,
  expires: true,
  expirationDate: true,
  contactInfo: true,
});
